import lightFormat from 'date-fns/lightFormat';
import * as accounting from 'accounting-js';
//import * as appProperties from 'appProperties';

/* General */
//export const SERVER_URL=appProperties["main.server_url"]; //'http://okami:8080';
export const TIMEOUT_MS=6 * 60 * 60 * 1000;
export const MAX_AGO_DAYS_MS= 90 * (1000*60*60*24);
export const MS_DAY = (1000*60*60*24);

/* ERD */
export const CONST_CANVASSIZE = {x:1000,y:500};
export const CONST_BOXSIZE = {x:160,y:110};
export const CONST_BOXPAD = {x:10,y:10};
export const CONST_PADDING=20;
export const CONST_APPSIZE = {x:160,y:80};

export const CONST_EMBEDFIELD_PAYLOADFIELD=1001;
export const CONST_EMBEDFIELD_GRIDFIELD=1002;

export const CONST_CODE_RETURN="[@CODE_RESULT]"
export const CONST_PLUGIN_RETURN="[@PLUGIN_RESULT]"
var junkid = -8001;

import { axios } from '@bundled-es-modules/axios/index.js';
import isEqual from 'lodash-es/isEqual';

export var notificationlist = [];



export const config = {
	menuItems: [
		{href:"/index.html",name:"Home",hash:false},
		{href:"https://thesuperlandlord.com/blog/",name:"Blog",hash:true},
		{href:"/index.html#newsletter",name:"Newsletter",hash:true},
		{href:"/index.html#contact",name:"Contact Us",hash:true}

	]
	/*
		{href:"/videopodcast",name:"Video Podcast"}
		{href:"/index.html#courses",name:"Courses"},
		{href:"/videopodcast",name:"Video Podcast"},

		{href:"/videopodcast",name:"videopodcast",hash:false},

	*/
}

export var currentPath = 'index.html';
export function setPath(p) {
	currentPath = p;
}

export function init() {
  ;
}

export function getServer(path) {
  //console.log('appProperties', appProperties, appProperties["main.server_url"]);
  /*
  if (!path) return SERVER_URL;
  else if (path.charAt(0)=='/') return SERVER_URL+path;
  else return SERVER_URL+"/"+path;
  */
  //return "http://localhost:8062"+"/"+path;
  return "https://thesuperlandlord.com/"+path;
}


export function goError() {
  //location.href="/assets/error/error404.html";
  console.log("======== GO ERROR! ======== (debug)")
  return;
}
export function goLogin() {
  location.href="/login";
  return;
}


export function getTail(basestring) {
  var ret = '';
  var href = window.location.href
  var idxbase = href.indexOf(basestring);
  var tmpref = href.substring(idxbase);
  var idxslash = tmpref.lastIndexOf('/');
  tmpref = tmpref.substring(idxslash+1);
  var idxhash = tmpref.indexOf('#');
  var idxques = tmpref.indexOf('?');
  if (idxhash>0 && idxques>0) ret = (idxhash > idxques) ? tmpref.substring(0,idxques) : tmpref.substring(0,idxhash);
  else if (idxques>0) ret = tmpref.substring(0,idxques);
  else if (idxhash>0) ret = tmpref.substring(0,idxhash);
  else ret = tmpref;



  console.log('getTail(', basestring, ')=', ret);
  return ret;
}

export function getParams() {
  var vars = {};
  var idxhash = window.location.href.indexOf('#');
  var idxques = window.location.href.indexOf('?');
  var href = (idxhash > idxques) ? window.location.href.substring(0,window.location.href.indexOf('#')) : window.location.href;
  //var nohash = window.location.href.substring(0,window.location.href.indexOf('#'));
  console.log('getParams() href=', href);
  var parts = href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[decodeURIComponent(key)] = value;
  });
  return vars;
}

export function getHashParams() {

  var hashParams = {};
  var idxhash = window.location.href.indexOf('#');
  var idxques = window.location.href.indexOf('?');
  //var q = (idxques > idxhash) ? window.location.href.substring(1,window.location.hash.indexOf('?')) : window.location.hash.substring(1);

  var e,
      a = /\+/g,  // Regex for replacing addition symbol with a space
      r = /([^&;=]+)=?([^&;]*)/g,
      d = function (s) { return decodeURIComponent(s.replace(a, " ")); },
      //q = window.location.hash.substring(1, window.location.hash.indexOf('?'));
      q = (idxques > idxhash) ? window.location.hash.substring(1,window.location.hash.indexOf('?')) : window.location.hash.substring(1);
      console.log('getHashParams() q',q);
  while (e = r.exec(q))
     hashParams[d(e[1])] = d(e[2]);

  return hashParams;
}

export function replaceQuery(url, param, value) {
    //var re = new RegExp("[\\?&]" + param + "=([^&#]*)"), match = re.exec(url), delimiter, newString;
    var re = new RegExp("[\\?&]" + param + "=([^&#]*)", "i"), match = re.exec(url), delimiter, newString;

    if (match === null) {
        // append new param
        var hasQuestionMark = /\?/.test(url);
        delimiter = hasQuestionMark ? "&" : "?";
        newString = url + delimiter + param + "=" + value;
    } else {
        delimiter = match[0].charAt(0);
        newString = url.replace(re, delimiter + param + "=" + value);
    }

    return newString;
}

export function replaceHash(url, param, value) {
  //var re = new RegExp("[\\?&]" + param + "=([^&#]*)"), match = re.exec(url), delimiter, newString;
  var re = new RegExp("[\\#&]" + param + "=([^&#]*)", "i"), match = re.exec(url), delimiter, newString;

  if (match === null) {
      // append new param
      var hasQuestionMark = /\#/.test(url);
      delimiter = hasQuestionMark ? "&" : "#";
      newString = url + delimiter + param + "=" + value;
  } else {
      delimiter = match[0].charAt(0);
      newString = url.replace(re, delimiter + param + "=" + value);
  }

  return newString;
}

export function calculateCost(product, disksize) {
  var cost=500.00;
  if (product=='PostgreSQL') {
    if (disksize==1) cost=19.99;
    else if (disksize>=2 && disksize<=6) cost=19.99+(disksize-1)*5.0;
    else if (disksize>=7 && disksize<=9) cost=disksize*8.5;
    else if (disksize>=10 && disksize<=49) cost=disksize*8.5;
    else if (disksize>=50) cost= (49*8.5) + (disksize-49)*7.5;
  } else if (product=='MySQL') {
    if (disksize==1) cost=19.99;
    else if (disksize>=2 && disksize<=6) cost=19.99+(disksize-1)*5.0;
    else if (disksize>=7 && disksize<=9) cost=disksize*8.5;
    else if (disksize>=10 && disksize<=49) cost=disksize*8.5;
    else if (disksize>=50) cost= (49*8.5) + (disksize-49)*7.5;
  } else if (product=='CouchDB') {
    if (disksize==1) cost=19.99;
    else if (disksize>=2 && disksize<=6) cost=19.99+(disksize-1)*9.0;
    else if (disksize>=7 && disksize<=9) cost=disksize*12;
    else if (disksize>=10 && disksize<=49) cost=disksize*11;
    else if (disksize>=50) cost= (49*11) + (disksize-49)*10;
  } else if (product=='Redis') {
    if (disksize==1) cost=19.99;
    else if (disksize>=2 && disksize<=6) cost=19.99+(disksize-1)*9.0;
    else if (disksize>=7 && disksize<=9) cost=disksize*12;
    else if (disksize>=10 && disksize<=49) cost=disksize*11;
    else if (disksize>=50) cost= (49*11) + (disksize-49)*10;
  } else if (product=='MongoDB') {
    if (disksize==1) cost=19.99;
    else if (disksize>=2 && disksize<=6) cost=19.99+(disksize-1)*9.0;
    else if (disksize>=7 && disksize<=9) cost=disksize*12;
    else if (disksize>=10 && disksize<=49) cost=disksize*11;
    else if (disksize>=50) cost= (49*11) + (disksize-49)*10;
  } else {
    if (disksize==1) cost=19.99;
    else if (disksize>=2 && disksize<=6) cost=19.99+(disksize-1)*9.0;
    else if (disksize>=7 && disksize<=9) cost=disksize*12;
    else if (disksize>=10 && disksize<=49) cost=disksize*8.5;
    else if (disksize>=50) cost= (49*8.5) + (disksize-49)*7.5;
  }
  return cost;
}
export function getRamDisp(ramsize) {
  var ramunit = 'MB';
  if (ramsize > 1024.00) {
    ramsize = ramsize / 1024.00;
    ramunit = 'GB';
  }
  return accounting.toFixed(ramsize,1) + ' ' + ramunit;
}

export function validateEmail(email) {
    const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

    return expression.test(String(email).toLowerCase())
}

export function isJson(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}
/*
export function removeClass( classname, element ) {
  var cn = element.className;
  var rxp = new RegExp( "s?b"+classname+"b", "g" );
  cn = cn.replace( rxp, '' );
  element.className = cn;
  console.log('removeClass', element.className);
}
*/
export function removeClass(el, className) {
  if (el.classList)
    el.classList.remove(className)
  else if (hasClass(el, className)) {
    var reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
    el.className=el.className.replace(reg, ' ')
  }
  console.log('removeClass', el.className);
}
export function addClass( element, classname  ) {
  var cn = element.className;
  //test for existance
  if( cn.indexOf( classname ) != -1 ) {
      return;
  }
  //add a space if the element already has class
  if( cn != '' ) {
      classname = ' '+classname;
  }
  console.log('props.addClass() element.className=', cn+classname);
  element.className = cn+classname;
}
 export function findArrayMapIndex(arr, key, val) {
   if (!arr) return -1;
   for (var i=arr.length-1; i>=0; i--) {
     if (arr[i]==null || arr[i][key]==null) continue;
     if (arr[i][key]==val) return i;
   }
   return -1;
 }
 export function findArrayMap(arr, key, val) {
   var idx = findArrayMapIndex(arr, key, val);
   if (idx>=0) return arr[idx];
   else return null;
 }
  export function arrayRemove(arr, value) {
      return arr.filter(function(ele){
          return ele != value;
      });
  }


/*
export function renderFullTimeAgo(millis) {
  var d = new Date(millis);
  console.log('millis', millis, d);
  return datefns.format(d, 'MMMM Do YYYY, h:mm:ss a') + ' ('+ datefns.formatDistanceToNow(d) +')';
}
*/

export function renderDate(millis) {
  if (!millis) return "";
  var d= new Date(millis);
  //var mdate = moment(millis)
  //return mdate.format('MM/d/YYYY');
  return lightFormat(d, 'MM/dd/yy');
}

export function renderDateReadable(millis) {
  var d= new Date(millis);
  //var mdate = moment(millis)
  //return mdate.format('MM/d/YYYY');
  //console.log('d.getYear()', d.getYear());
  if (d.getYear()==(new Date()).getYear()) return lightFormat(d, 'MMM dd');
  else return lightFormat(d, "MMM dd 'yy");
}

export function renderDateTime(millis) {
  if (!millis) return "";
  var d= new Date(millis);
  //console.log('millis', millis, d);
  //moment().format('MMMM Do YYYY, h:mm:ss a'); // February 26th 2017, 5:17:58 pm
  //var mdate = moment(millis)
  //return datefns.format(d, 'MMM Do YYYY, h:mm a');
  return lightFormat(d, 'MM/dd/yy h:mm a');
}
export function renderTime(millis) {
  if (!millis) return "";
  var d= new Date(millis);
  //var mdate = moment(millis)
  return lightFormat(d, 'h:mm a');
}

/*
export function renderAgo(millis) {
  var d= new Date(millis);
  console.log('millis', millis, d);
  //moment().format('MMMM Do YYYY, h:mm:ss a'); // February 26th 2017, 5:17:58 pm
  //var mdate = moment(millis)
  return datefns.formatDistanceToNow(d);
}
*/

export function cutOff(str, maxlen) {
  if (str.length>maxlen) return str.substring(0, maxlen) + "...";
  else return str;
}


export function selectValue(s, v) {
  if (!s || !s.options || s.options.length<=0) return;
  console.log('selectValue(',s,v,')', 's.options.length', s.options.length);
  for ( var i = 0; i < s.options.length; i++ ) {
      if ( s.options[i].value == v ) {
          console.log('selectValue() FOUND=',v);
          s.options[i].selected = true;
          return;
      }
  }
} //selectValue()
export function getSelected(s) {
  if (!s || !s.options || s.options.length<=0) return;
  return s.options[s.selectedIndex].value;
} //getValue()


export function compareValues(key, order = 'asc') {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = (typeof a[key] === 'string')
      ? a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string')
      ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    //console.log("COMPARE: ", varA, varB, comparison);
    return (
      (order === 'desc') ? (comparison * -1) : comparison
    );
  };
}

export function isBlank(str) {
  if (!str) return true;
  return str === null || str.match(/^\s*$/) !== null;
}

export function delay(fn, ms) {
  let timer = 0
  //console.log('DELAY!', ms, fn);
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(fn.bind(this, ...args), ms || 0);
    console.log('DELAY! timer', timer);
  }
}

export const debounce = (func, wait) => {
  let timeout;
    console.log('debounce!', wait);

  // This is the function that is returned and will be executed many times
  // We spread (...args) to capture any number of parameters we want to pass
  return function executedFunction(...args) {
        console.log('executedFunction', args);

    // The callback function to be executed after
    // the debounce time has elapsed
    const later = () => {
      // null timeout to indicate the debounce ended
      timeout = null;

      // Execute the callback
      func(...args);
    };
    // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the
    // inside of the previous setTimeout
    console.log('clear timeout', timeout);
    clearTimeout(timeout);

    // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs Node)
    timeout = setTimeout(later, wait);
    console.log('set timeout', timeout);
  };
};

export function debounced(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


export const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;

export function arraysEqual(arr1, arr2) {

	// Check if the arrays are the same length
	if (arr1.length !== arr2.length) return false;

	// Check if all items exist and are in the same order
	for (var i = 0; i < arr1.length; i++) {
		if (arr1[i] !== arr2[i]) return false;
	}

	// Otherwise, return true
	return true;

};

export function getPromiseFromEvent(item, event) {
  return new Promise((resolve) => {
    const listener = () => {
      item.removeEventListener(event, listener);
      resolve();
    }
    item.addEventListener(event, listener);
  })
}

export function syslogapi(requrl, error) {
  console.log(prtfun(), '/api/syslogapi', {requrl, error});
  let errorobj = new Error(error);
  let payload = {error:errorobj.stack, src:requrl, class:"",event:"api",app:"lightspoke.lit"};
  payload.error = {"message":errorobj.message, "stack":errorobj.stack};
  if (error.response) {
    payload.title = `${requrl} ${error.response.data.error}: ${error.response.data.message}`;
  } else if (error.request) {
    payload.title = `${requrl} NO_SERVER_RESPONSE: ${errorobj.message}`;
  }
  console.log(prtfun(), '/api/syslogapi', {payload});

  syslog(payload);
  return;
}



export function getFilePathExtension(path) {
	var filename = path.split('\\').pop().split('/').pop();
	var lastIndex = filename.lastIndexOf(".");
	if (lastIndex < 1) return "";
	return filename.substr(lastIndex + 1);
}

export function isImageExt(filename) {
  let fileext = getFilePathExtension(filename);
  let imageexts =  ["jpg","jpeg","gif","png","svg","tiff","bmp"];

  let imagemedia = ["jpg","jpeg","gif","png","svg+xml","tiff","bmp"];
  let contenttype = null;
  for (let i in imageexts) {
    if (fileext==imageexts[i]) contenttype = imagemedia[i];
  }
  return (contenttype);
}


export function popImage(imageURL,imageTitle){
  let PositionX = 10;
  let PositionY = 10;
  let defaultWidth  = 600;
  let defaultHeight = 400;

  //kinda important
  let AutoClose = false;

  var imgWin = window.open('','_blank','scrollbars=no,resizable=1,width='+defaultWidth+',height='+defaultHeight+',left='+PositionX+',top='+PositionY);
  if( !imgWin ) { return true; } //popup blockers should not cause errors
  imgWin.document.write('<html><head><title>'+imageTitle+'<\/title><script type="text\/javascript">\n'+
    'function resizeWinTo() {\n'+
    'if( !document.images.length ) { document.images[0] = document.layers[0].images[0]; }'+
    'var oH = document.images[0].height, oW = document.images[0].width;\n'+
    'let ratio=oW/1024; console.log("======RATIO1="+ratio);if (ratio>1.0) {oH=oH/ratio;oW=oW/ratio;} console.log("======RATIO2="+ratio, oW,oH);\n'+
    'if( !oH || window.doneAlready ) { return; }\n'+ //in case images are disabled
    'window.doneAlready = true;\n'+ //for Safari and Opera
    'var x = window; x.resizeTo( oW + 200, oH + 200 );\n'+
    'var myW = 0, myH = 0, d = x.document.documentElement, b = x.document.body;\n'+
    'if( x.innerWidth ) { myW = x.innerWidth; myH = x.innerHeight; }\n'+
    'else if( d && d.clientWidth ) { myW = d.clientWidth; myH = d.clientHeight; }\n'+
    'else if( b && b.clientWidth ) { myW = b.clientWidth; myH = b.clientHeight; }\n'+
    '/*if( window.opera && !document.childNodes ) { myW += 16; }\n'+
    'x.resizeTo( oW = oW + ( ( oW + 200 ) - myW ), oH = oH + ( (oH + 200 ) - myH ) );\n'+
    'var scW = screen.availWidth ? screen.availWidth : screen.width;\n'+
    'var scH = screen.availHeight ? screen.availHeight : screen.height;\n'+
    'if( !window.opera ) { x.moveTo(Math.round((scW-oW)/2),Math.round((scH-oH)/2)); }\n*/'+
    'console.log("======RATIO3="+ratio, oW,oH);\n'+
    '}\n'+
    '<\/script>'+
    '<\/head><body onload="resizeWinTo();"'+(AutoClose?' onblur="self.close();"':'')+'>'+
    (document.layers?('<layer left="0" top="0">'):('<div style="position:absolute;left:0px;top:0px;display:table;">'))+
    '<img src="'+imageURL+'" alt="Loading image ..." title="" onload="resizeWinTo();">'+
    (document.layers?'<\/layer>':'<\/div>')+'<\/body><\/html>');
  imgWin.document.close();
  if( imgWin.focus ) { imgWin.focus(); }
  return false;
}

//export const StateList = ['Alabama','Alaska','American Samoa','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Federated States of Micronesia','Florida','Georgia','Guam','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Marshall Islands','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Northern Mariana Islands','Ohio','Oklahoma','Oregon','Palau','Pennsylvania','Puerto Rico','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virgin Island','Virginia','Washington','West Virginia','Wisconsin','Wyoming']
export const StateList = [{"v":"Alabama","k":"AL"},{"v":"Alaska","k":"AK"},{"v":"American Samoa","k":"AS"},{"v":"Arizona","k":"AZ"},{"v":"Arkansas","k":"AR"},{"v":"California","k":"CA"},{"v":"Colorado","k":"CO"},{"v":"Connecticut","k":"CT"},{"v":"Delaware","k":"DE"},{"v":"District Of Columbia","k":"DC"},{"v":"Federated States Of Micronesia","k":"FM"},{"v":"Florida","k":"FL"},{"v":"Georgia","k":"GA"},{"v":"Guam","k":"GU"},{"v":"Hawaii","k":"HI"},{"v":"Idaho","k":"ID"},{"v":"Illinois","k":"IL"},{"v":"Indiana","k":"IN"},{"v":"Iowa","k":"IA"},{"v":"Kansas","k":"KS"},{"v":"Kentucky","k":"KY"},{"v":"Louisiana","k":"LA"},{"v":"Maine","k":"ME"},{"v":"Marshall Islands","k":"MH"},{"v":"Maryland","k":"MD"},{"v":"Massachusetts","k":"MA"},{"v":"Michigan","k":"MI"},{"v":"Minnesota","k":"MN"},{"v":"Mississippi","k":"MS"},{"v":"Missouri","k":"MO"},{"v":"Montana","k":"MT"},{"v":"Nebraska","k":"NE"},{"v":"Nevada","k":"NV"},{"v":"New Hampshire","k":"NH"},{"v":"New Jersey","k":"NJ"},{"v":"New Mexico","k":"NM"},{"v":"New York","k":"NY"},{"v":"North Carolina","k":"NC"},{"v":"North Dakota","k":"ND"},{"v":"Northern Mariana Islands","k":"MP"},{"v":"Ohio","k":"OH"},{"v":"Oklahoma","k":"OK"},{"v":"Oregon","k":"OR"},{"v":"Palau","k":"PW"},{"v":"Pennsylvania","k":"PA"},{"v":"Puerto Rico","k":"PR"},{"v":"Rhode Island","k":"RI"},{"v":"South Carolina","k":"SC"},{"v":"South Dakota","k":"SD"},{"v":"Tennessee","k":"TN"},{"v":"Texas","k":"TX"},{"v":"Utah","k":"UT"},{"v":"Vermont","k":"VT"},{"v":"Virgin Islands","k":"VI"},{"v":"Virginia","k":"VA"},{"v":"Washington","k":"WA"},{"v":"West Virginia","k":"WV"},{"v":"Wisconsin","k":"WI"},{"v":"Wyoming","k":"WY"}];
export const CountryList = [
  {"name": "Afghanistan", "code": "AF"},
  {"name": "land Islands", "code": "AX"},
  {"name": "Albania", "code": "AL"},
  {"name": "Algeria", "code": "DZ"},
  {"name": "American Samoa", "code": "AS"},
  {"name": "AndorrA", "code": "AD"},
  {"name": "Angola", "code": "AO"},
  {"name": "Anguilla", "code": "AI"},
  {"name": "Antarctica", "code": "AQ"},
  {"name": "Antigua and Barbuda", "code": "AG"},
  {"name": "Argentina", "code": "AR"},
  {"name": "Armenia", "code": "AM"},
  {"name": "Aruba", "code": "AW"},
  {"name": "Australia", "code": "AU"},
  {"name": "Austria", "code": "AT"},
  {"name": "Azerbaijan", "code": "AZ"},
  {"name": "Bahamas", "code": "BS"},
  {"name": "Bahrain", "code": "BH"},
  {"name": "Bangladesh", "code": "BD"},
  {"name": "Barbados", "code": "BB"},
  {"name": "Belarus", "code": "BY"},
  {"name": "Belgium", "code": "BE"},
  {"name": "Belize", "code": "BZ"},
  {"name": "Benin", "code": "BJ"},
  {"name": "Bermuda", "code": "BM"},
  {"name": "Bhutan", "code": "BT"},
  {"name": "Bolivia", "code": "BO"},
  {"name": "Bosnia and Herzegovina", "code": "BA"},
  {"name": "Botswana", "code": "BW"},
  {"name": "Bouvet Island", "code": "BV"},
  {"name": "Brazil", "code": "BR"},
  {"name": "British Indian Ocean Territory", "code": "IO"},
  {"name": "Brunei Darussalam", "code": "BN"},
  {"name": "Bulgaria", "code": "BG"},
  {"name": "Burkina Faso", "code": "BF"},
  {"name": "Burundi", "code": "BI"},
  {"name": "Cambodia", "code": "KH"},
  {"name": "Cameroon", "code": "CM"},
  {"name": "Canada", "code": "CA"},
  {"name": "Cape Verde", "code": "CV"},
  {"name": "Cayman Islands", "code": "KY"},
  {"name": "Central African Republic", "code": "CF"},
  {"name": "Chad", "code": "TD"},
  {"name": "Chile", "code": "CL"},
  {"name": "China", "code": "CN"},
  {"name": "Christmas Island", "code": "CX"},
  {"name": "Cocos (Keeling) Islands", "code": "CC"},
  {"name": "Colombia", "code": "CO"},
  {"name": "Comoros", "code": "KM"},
  {"name": "Congo", "code": "CG"},
  {"name": "Congo, The Democratic Republic of the", "code": "CD"},
  {"name": "Cook Islands", "code": "CK"},
  {"name": "Costa Rica", "code": "CR"},
  {"name": "Cote D'Ivoire", "code": "CI"},
  {"name": "Croatia", "code": "HR"},
  {"name": "Cuba", "code": "CU"},
  {"name": "Cyprus", "code": "CY"},
  {"name": "Czech Republic", "code": "CZ"},
  {"name": "Denmark", "code": "DK"},
  {"name": "Djibouti", "code": "DJ"},
  {"name": "Dominica", "code": "DM"},
  {"name": "Dominican Republic", "code": "DO"},
  {"name": "Ecuador", "code": "EC"},
  {"name": "Egypt", "code": "EG"},
  {"name": "El Salvador", "code": "SV"},
  {"name": "Equatorial Guinea", "code": "GQ"},
  {"name": "Eritrea", "code": "ER"},
  {"name": "Estonia", "code": "EE"},
  {"name": "Ethiopia", "code": "ET"},
  {"name": "Falkland Islands (Malvinas)", "code": "FK"},
  {"name": "Faroe Islands", "code": "FO"},
  {"name": "Fiji", "code": "FJ"},
  {"name": "Finland", "code": "FI"},
  {"name": "France", "code": "FR"},
  {"name": "French Guiana", "code": "GF"},
  {"name": "French Polynesia", "code": "PF"},
  {"name": "French Southern Territories", "code": "TF"},
  {"name": "Gabon", "code": "GA"},
  {"name": "Gambia", "code": "GM"},
  {"name": "Georgia", "code": "GE"},
  {"name": "Germany", "code": "DE"},
  {"name": "Ghana", "code": "GH"},
  {"name": "Gibraltar", "code": "GI"},
  {"name": "Greece", "code": "GR"},
  {"name": "Greenland", "code": "GL"},
  {"name": "Grenada", "code": "GD"},
  {"name": "Guadeloupe", "code": "GP"},
  {"name": "Guam", "code": "GU"},
  {"name": "Guatemala", "code": "GT"},
  {"name": "Guernsey", "code": "GG"},
  {"name": "Guinea", "code": "GN"},
  {"name": "Guinea-Bissau", "code": "GW"},
  {"name": "Guyana", "code": "GY"},
  {"name": "Haiti", "code": "HT"},
  {"name": "Heard Island and Mcdonald Islands", "code": "HM"},
  {"name": "Holy See (Vatican City State)", "code": "VA"},
  {"name": "Honduras", "code": "HN"},
  {"name": "Hong Kong", "code": "HK"},
  {"name": "Hungary", "code": "HU"},
  {"name": "Iceland", "code": "IS"},
  {"name": "India", "code": "IN"},
  {"name": "Indonesia", "code": "ID"},
  {"name": "Iran, Islamic Republic Of", "code": "IR"},
  {"name": "Iraq", "code": "IQ"},
  {"name": "Ireland", "code": "IE"},
  {"name": "Isle of Man", "code": "IM"},
  {"name": "Israel", "code": "IL"},
  {"name": "Italy", "code": "IT"},
  {"name": "Jamaica", "code": "JM"},
  {"name": "Japan", "code": "JP"},
  {"name": "Jersey", "code": "JE"},
  {"name": "Jordan", "code": "JO"},
  {"name": "Kazakhstan", "code": "KZ"},
  {"name": "Kenya", "code": "KE"},
  {"name": "Kiribati", "code": "KI"},
  {"name": "Korea, Democratic People's Republic of", "code": "KP"},
  {"name": "Korea, Republic of", "code": "KR"},
  {"name": "Kuwait", "code": "KW"},
  {"name": "Kyrgyzstan", "code": "KG"},
  {"name": "Lao People's Democratic Republic", "code": "LA"},
  {"name": "Latvia", "code": "LV"},
  {"name": "Lebanon", "code": "LB"},
  {"name": "Lesotho", "code": "LS"},
  {"name": "Liberia", "code": "LR"},
  {"name": "Libyan Arab Jamahiriya", "code": "LY"},
  {"name": "Liechtenstein", "code": "LI"},
  {"name": "Lithuania", "code": "LT"},
  {"name": "Luxembourg", "code": "LU"},
  {"name": "Macao", "code": "MO"},
  {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
  {"name": "Madagascar", "code": "MG"},
  {"name": "Malawi", "code": "MW"},
  {"name": "Malaysia", "code": "MY"},
  {"name": "Maldives", "code": "MV"},
  {"name": "Mali", "code": "ML"},
  {"name": "Malta", "code": "MT"},
  {"name": "Marshall Islands", "code": "MH"},
  {"name": "Martinique", "code": "MQ"},
  {"name": "Mauritania", "code": "MR"},
  {"name": "Mauritius", "code": "MU"},
  {"name": "Mayotte", "code": "YT"},
  {"name": "Mexico", "code": "MX"},
  {"name": "Micronesia, Federated States of", "code": "FM"},
  {"name": "Moldova, Republic of", "code": "MD"},
  {"name": "Monaco", "code": "MC"},
  {"name": "Mongolia", "code": "MN"},
  {"name": "Montenegro", "code": "ME"},
  {"name": "Montserrat", "code": "MS"},
  {"name": "Morocco", "code": "MA"},
  {"name": "Mozambique", "code": "MZ"},
  {"name": "Myanmar", "code": "MM"},
  {"name": "Namibia", "code": "NA"},
  {"name": "Nauru", "code": "NR"},
  {"name": "Nepal", "code": "NP"},
  {"name": "Netherlands", "code": "NL"},
  {"name": "Netherlands Antilles", "code": "AN"},
  {"name": "New Caledonia", "code": "NC"},
  {"name": "New Zealand", "code": "NZ"},
  {"name": "Nicaragua", "code": "NI"},
  {"name": "Niger", "code": "NE"},
  {"name": "Nigeria", "code": "NG"},
  {"name": "Niue", "code": "NU"},
  {"name": "Norfolk Island", "code": "NF"},
  {"name": "Northern Mariana Islands", "code": "MP"},
  {"name": "Norway", "code": "NO"},
  {"name": "Oman", "code": "OM"},
  {"name": "Pakistan", "code": "PK"},
  {"name": "Palau", "code": "PW"},
  {"name": "Palestinian Territory, Occupied", "code": "PS"},
  {"name": "Panama", "code": "PA"},
  {"name": "Papua New Guinea", "code": "PG"},
  {"name": "Paraguay", "code": "PY"},
  {"name": "Peru", "code": "PE"},
  {"name": "Philippines", "code": "PH"},
  {"name": "Pitcairn", "code": "PN"},
  {"name": "Poland", "code": "PL"},
  {"name": "Portugal", "code": "PT"},
  {"name": "Puerto Rico", "code": "PR"},
  {"name": "Qatar", "code": "QA"},
  {"name": "Reunion", "code": "RE"},
  {"name": "Romania", "code": "RO"},
  {"name": "Russian Federation", "code": "RU"},
  {"name": "RWANDA", "code": "RW"},
  {"name": "Saint Helena", "code": "SH"},
  {"name": "Saint Kitts and Nevis", "code": "KN"},
  {"name": "Saint Lucia", "code": "LC"},
  {"name": "Saint Pierre and Miquelon", "code": "PM"},
  {"name": "Saint Vincent and the Grenadines", "code": "VC"},
  {"name": "Samoa", "code": "WS"},
  {"name": "San Marino", "code": "SM"},
  {"name": "Sao Tome and Principe", "code": "ST"},
  {"name": "Saudi Arabia", "code": "SA"},
  {"name": "Senegal", "code": "SN"},
  {"name": "Serbia", "code": "RS"},
  {"name": "Seychelles", "code": "SC"},
  {"name": "Sierra Leone", "code": "SL"},
  {"name": "Singapore", "code": "SG"},
  {"name": "Slovakia", "code": "SK"},
  {"name": "Slovenia", "code": "SI"},
  {"name": "Solomon Islands", "code": "SB"},
  {"name": "Somalia", "code": "SO"},
  {"name": "South Africa", "code": "ZA"},
  {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
  {"name": "Spain", "code": "ES"},
  {"name": "Sri Lanka", "code": "LK"},
  {"name": "Sudan", "code": "SD"},
  {"name": "Suriname", "code": "SR"},
  {"name": "Svalbard and Jan Mayen", "code": "SJ"},
  {"name": "Swaziland", "code": "SZ"},
  {"name": "Sweden", "code": "SE"},
  {"name": "Switzerland", "code": "CH"},
  {"name": "Syrian Arab Republic", "code": "SY"},
  {"name": "Taiwan, Province of China", "code": "TW"},
  {"name": "Tajikistan", "code": "TJ"},
  {"name": "Tanzania, United Republic of", "code": "TZ"},
  {"name": "Thailand", "code": "TH"},
  {"name": "Timor-Leste", "code": "TL"},
  {"name": "Togo", "code": "TG"},
  {"name": "Tokelau", "code": "TK"},
  {"name": "Tonga", "code": "TO"},
  {"name": "Trinidad and Tobago", "code": "TT"},
  {"name": "Tunisia", "code": "TN"},
  {"name": "Turkey", "code": "TR"},
  {"name": "Turkmenistan", "code": "TM"},
  {"name": "Turks and Caicos Islands", "code": "TC"},
  {"name": "Tuvalu", "code": "TV"},
  {"name": "Uganda", "code": "UG"},
  {"name": "Ukraine", "code": "UA"},
  {"name": "United Arab Emirates", "code": "AE"},
  {"name": "United Kingdom", "code": "GB"},
  {"name": "United States", "code": "US"},
  {"name": "United States Minor Outlying Islands", "code": "UM"},
  {"name": "Uruguay", "code": "UY"},
  {"name": "Uzbekistan", "code": "UZ"},
  {"name": "Vanuatu", "code": "VU"},
  {"name": "Venezuela", "code": "VE"},
  {"name": "Viet Nam", "code": "VN"},
  {"name": "Virgin Islands, British", "code": "VG"},
  {"name": "Virgin Islands, U.S.", "code": "VI"},
  {"name": "Wallis and Futuna", "code": "WF"},
  {"name": "Western Sahara", "code": "EH"},
  {"name": "Yemen", "code": "YE"},
  {"name": "Zambia", "code": "ZM"},
  {"name": "Zimbabwe", "code": "ZW"}
  ];




export function postAjax(url, data, success) {
    var params = typeof data == 'string' ? data : Object.keys(data).map(
            function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
        ).join('&');

    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open('POST', url);
    xhr.onreadystatechange = function() {
        if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(params);
    return xhr;
}

export function makeid(length) {
   if (!length || length < 1) length=6;
   const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   const alphas = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
   const charactersLength = characters.length;

   var result = alphas.charAt(Math.floor(Math.random() * alphas.length));
   for ( var i = 0; i < length-1; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

export function getRadioValue(tagname) {
  var radios = document.getElementsByName(tagname);
  for (var i = 0, length = radios.length; i < length; i++) {
    if (radios[i].checked) {
      console.log('checked value:', radios[i]);
      return radios[i].value;
      break;
    }
  }
}

export function setRadioValue(tagname, val) {
  let radios = document.getElementsByName(tagname);
  console.log('setRadioValue(tagname, val)', tagname, val, 'radios.length', radios.length, radios);
  for (let i=0; i<radios.length; i++) {
    console.log('******radio compare', radios[i].value, val)
    if (radios[i].value==val) {
      radios[i].checked=true;
      break;
    }
  }
}

export function cloneArray(list) {
  let ret = [list.length];
  for (let i = 0; i < list.length; i++) { ret[i] = list[i]; }
  return ret;
}
export function clone2dArray(list) {
  let ret = [list.length];
  for (let i = 0; i < list.length; i++) {
    for (let j=0; j<list[i].length; j++) {
      ret[i][j] = list[i][j];
    }
  }
  return ret;
}

export function triggerEvent(el, type) {
    // IE9+ and other modern browsers
    if ('createEvent' in document) {
        var e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        el.dispatchEvent(e);
    } else {
        // IE8
        var e = document.createEventObject();
        e.eventType = type;
        el.fireEvent('on' + e.eventType, e);
    }
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


export function stripHtml(html) {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}


export function removeAllChildNodes(parent) {
  if (!parent) return;
  while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
  }
}

export function junkId() {
  return --junkid;
}

export function prtfun() {
  let errstack = new Error().stack.split('\n');
  //console.log(new Error().stack);
  let bugl = errstack[2];
  let debugprint = bugl.slice(bugl.indexOf("at ")+3, bugl.indexOf(" ("));
  if (debugprint.indexOf("http")==0) {
    //console.log('prtfun() bugl no context... errstack', errstack);
    for (let i=3; i<errstack.length;i++) {
      bugl = errstack[i];
      if (bugl.indexOf(".js:")>0) {
        debugprint = bugl.slice(bugl.indexOf("at ")+3, bugl.indexOf(" ("));
        break;
      }
    } //for
  } //if no module
  if (debugprint.indexOf("http")==0) {
    //console.log('prtfun() complete stack', errstack);
    //console.log('prtfun() complete stack2 Error.captureStackTrace:', Error.captureStackTrace(errstack));
    //console.trace();
  }
  return debugprint;
}
export function log(txt) {
  let bugl = new Error().stack.split('\n')[2];
  console.log(bugl.slice(bugl.indexOf("at ")+3, bugl.indexOf(" (")), txt);
}

export function camelToDash(str) {
  if (str != str.toLowerCase()) {
   str = str.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
   if (str.charAt(0)=="-") str = str.substring(1);
  }
  return str;
}

export function parseJSON(str) {
  try {
     return JSON.parse(str);
  }
  catch (e) {
     //console.log(e);
     // Return a default object, or null based on use case.
     return null;
  }
}

export function isAppPath() {
    let _isApp = false;
    try {
      const surl = (window.location.pathname).split('/')[1];
      if (surl == "app") _isApp = true;
      console.log({surl, _isApp});
    }
    catch (e) {
      //console.log(e);
    }
    return _isApp;
}

export function pushHistory(navobj) {
  let history = parseJSON(sessionStorage.getItem("history"));
  let last = {};
  let isdup=false;
  if (!history) {
    history = [];
  } else {
    last = history[history.length-1];
    isdup = (last.path==navobj.path && isEqual(last.query, navobj.query))
  }
  console.log(prtfun(), {isdup, lastpath:last.path, navpath:navobj.path, last, navobj});
  if (!isdup) {
    history.push(navobj);
    sessionStorage.setItem("history", JSON.stringify(history));
    console.log("PROPS.pushHistory", {navobj, history});
  }


}
export function getHistory() {
  let history = parseJSON(sessionStorage.getItem("history"));
  return history;
}
export function prevHistory() {
  let history = parseJSON(sessionStorage.getItem("history"));
  console.log("PROPS.prevHistory", {history});
  if (history && history.length>1) return history[history.length-2];
  else return null;
}

export function updateHistory(path, docid, key, val) {
  //updates last history member...
  let history = parseJSON(sessionStorage.getItem("history"));
  console.log(prtfun(), {path, docid, key, val, history});
  if (!history) return;
  let hist = null;
  let i=-1;
  for (i=history.length-1; i>=0; i--) {
    hist = history[i];
    if (hist.path==path && hist.query && hist.query.docid==docid) break;
  }
  console.log(prtfun(), "found hist", {hist, path, docid, key, val});
  //let hist = history.pop();
  if (hist!=null) {
    hist[key]=val;
    history[i]=hist;
    sessionStorage.setItem("history", JSON.stringify(history));
  }
  console.log(prtfun(), "PROPS.updateHistory END", {key, val, history});
}


export function parseBoolean(str) {
  if (!str) return false;
  if (str.toLowerCase()=="true") return true;
  if (str.toLowerCase()=="yes") return true;
  if (str=="1") return true;
  return false;

}


export function getval(value) {
  return getdef(value, "");
}
export function getdef(value, defaultvalue) {
  if (value) return value;
  else return defaultvalue;
}

export function objectHash(obj) {
    let string = JSON.stringify(obj);
    let hash = 0;
    if (string.length == 0) return hash;
    for (let i = 0; i < string.length; i++) {
        let char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }

    return hash;

}

export function getTextWidth(text, font) {
  // re-use canvas object for better performance
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}



export function rot(text) {
  if (!text) return null;
  console.log('rot()', {text});

  const input = 'AB!@CD#$EF%^GH&*IJ()KL_+MN<>OP?-QR=,ST./UV;:WX~`YZab01cdef23ghij45klmn67opqr89stuvwxyz';
  let strs = Array.from(text);
  let len = (strs.length * 2) + 1;
  let offset = (input.length + len) % input.length;
  if (offset==0) offset=17;
  let output = input.slice(offset) + input.slice(0, offset);
  //console.log({len, offset, output, slice_offset:input.slice(offset)})
  let encoded="";
  strs.forEach((ch, i)=>{
    const index = input.indexOf(strs[i]);
    if (index>=0) {
      encoded += output[index];
    } else {
      encoded += strs[i];
    }
  });
  //console.log(props.prtfun(), {encoded});
  return encoded;
}



export function grow(text) {
  if (!text) return null;
  const input = 'AB!@CD#$EF%^GH&*IJ()KL_+MN<>OP?-QR=,ST./UV;:WX~`YZab01cdef23ghij45klmn67opqr89stuvwxyz';
  let strs = Array.from(text);
  let len = (strs.length * 2) + 1;
  let offset = (input.length + len) % input.length;
  if (offset==0) offset=17;
  let output = input.slice(offset) + input.slice(0, offset);
  let decoded = "";
  strs.forEach((ch, i)=>{
    const index = output.indexOf(strs[i]);
    if (index>=0) {
      decoded += input[index];
    } else {
      decoded += output[i];
    }
  });
  //console.log(props.prtfun(), {decoded});
  return decoded;

}


export function generateRandomString(length=6)  {
  return Math.random().toString(20).substr(2, length)
}

export function generateFullKey(jsonobj) {
  let len = JSON.stringify(jsonobj).length
  let key = generateRandomString() + "##" + len;
  let rotkey = rot(key);
  console.log({key, rotkey, jsonobj});
  return key+"||"+rotkey;
}
/*

export var log = function(){
  // 1. Convert args to a normal array
  var args = Array.prototype.slice.call(arguments);
  // 2. Prepend log prefix log string
  args.unshift(this.constructor.name + ": ");
  // 3. Pass along arguments to console.log
  console.log.apply(console, args);
}


export function renderHumanTime(millis) {
  var elapsedmillis = moment().millisecond() - millis;
  if (elapsedmillis >= 15*MILLIS_DAY) {
    return this.renderTime(millis);
  } else {
    return this.renderAgo(millis);
  }
}
*/


/*
class Props {


  constructor() {
    this.SERVER_URL='http://localhost:8080/';
    this.TIMEOUT_MS=6 * 60 * 60 * 1000;
  }

  getServer(path) {
    return this.SERVER_URL+"/"+path;
  }

}
export default Props;
*/